'use client';

import { IFAQ } from '@/sanity/lib/definitions';
import { PageHomeSchema } from '@/sanity/pages/PageHomeTemplate';

import { customRichTextComponent } from '@/sanity/sanityPortableText';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/shadcn/ui/accordion';
import { motion } from 'framer-motion';
import { PortableText, PortableTextBlock } from 'next-sanity';
import { useState } from 'react';

export default function FAQ({
  faqs,
}: {
  faqs: {
    questions: IFAQ;
  }[];
}) {
  const [active, setActive] = useState<string | undefined>(undefined);

  return (
    <Accordion
      className="flex flex-col  relative z-[5] w-full m-auto "
      type="single"
      collapsible
      onValueChange={setActive}
    >
      {faqs?.map((item, index) => {
        const value = `value-${index}`;
        const isActive = active === value;
        return (
          <motion.div
            whileInView={{
              opacity: 1,
              y: 0,
            }}
            initial={{
              opacity: 0,
              y: 20,
            }}
            viewport={{
              once: true,
              amount: 0.8,
            }}
            transition={{ duration: 0.3, delay: 0.2 + index * 0.1 }}
            className="relative"
            key={index}
          >
            <AccordionItem
              key={index}
              className="duration-300    w-full transition-all  z-[1]  relative border-t-[.125rem] border-[rgba(255,255,255,0.08)]
             "
              value={value}
            >
              <AccordionTrigger className="relative group">
                <div className="w-full lg:w-[85%] flex justify-start items-center gap-[2rem] lg:gap-[8.12rem]">
                  <span className="text-[#dadada] font-newsreader text-[2rem] lg:text-[3rem] italic font-[300] uppercase">
                    ({0<10 ? `0${index + 1}` : index + 1})
                  </span>
                  <h3 className="lg:text-[6rem] text-[2.5rem] text-[#dadada] font-newsreader font-[300] uppercase text-left leading-[120%] duration-100 transition-all flex items-start relative py-[5rem] lg:py-[8.5rem] z-[1] italic max-w-[82%] lg:max-w-[90%]">
                    {item?.questions.title}
                  </h3>
                </div>

                <div className="absolute z-0 w-full group-hover:scale-y-100 origin-bottom transition-all duration-500 scale-y-0 h-full bottom-0 left-0 bg-transparent group-hover:bg-[rgba(255,255,255,0.05)] group-data-[state=open]:scale-y-0"></div>
              </AccordionTrigger>
              <AccordionContent className="relative py-[5rem] lg:py-[8rem] border-t-[.125rem] border-[rgba(255,255,255,0.08)] z-[1] flex items-start gap-[2rem] lg:gap-[3rem] pl-[5rem] lg:pl-[13rem]">
                <svg
                  className="lg:w-[11.94rem] w-[6rem] min-w-[6rem] lg:min-w-[11.94rem]"
                  xmlns="http://www.w3.org/2000/svg"
                  width="96"
                  height="20"
                  fill="none"
                  viewBox="0 0 96 20"
                >
                  <path
                    fill="#8A8F93"
                    d="m88.239 10.635 7.285.025.007-1.19-7.286-.026c-4.502-.014-8.19-4.202-8.423-9.435L78.604 0c-.267 5.24-3.986 9.376-8.488 9.362L.006 9.075 0 10.265l70.11.287c4.501.015 8.19 4.202 8.422 9.435l1.219.01c.267-5.24 3.986-9.376 8.488-9.362"
                  ></path>
                </svg>
                <div className="flex flex-col gap-[3rem]">
                  {item?.questions?.text && (
                    <PortableText
                      //@ts-ignore
                      value={item?.questions?.text}
                      components={customRichTextComponent({
                        block: {
                          normal: ({ children }) => {
                            return (
                              <p className="text-[2rem] text-[#8A8F93] font-nunito font-[300] text-left leading-[140%] max-w-[90%] f">
                                {children}
                              </p>
                            );
                          },
                        },
                      })}
                    />
                  )}
                </div>
              </AccordionContent>
            </AccordionItem>
          </motion.div>
        );
      })}
    </Accordion>
  );
}
